import { BLACK_700, BLACK_900, BLUE_GREY_200, BLUE_GREY_500, BLACK_600, LILAC_300, LILAC_900, RED_600, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
var DIMENTIONS_SIZE = {
  desktop: 52,
  mobile: 40
};
var THEMES_CONFIG = {
  white: {
    imageIconColor: BLACK_900,
    containerBorderColor: BLUE_GREY_500,
    imageIconBgColor: BLUE_GREY_200,
    titleColor: BLACK_900,
    subtitleColor: BLACK_600
  },
  dark: {
    imageIconColor: LILAC_900,
    containerBorderColor: LILAC_900,
    imageIconBgColor: LILAC_300,
    titleColor: BLACK_900,
    subtitleColor: BLACK_700
  },
  light: {
    imageIconColor: LILAC_900,
    containerBorderColor: LILAC_900,
    imageIconBgColor: LILAC_300,
    titleColor: BLACK_900,
    subtitleColor: BLACK_700
  }
};
export var getUploadSingleFileUIProp = (isLargeScreen, theme) => {
  var height = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var width = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var _THEMES_CONFIG$theme = THEMES_CONFIG[theme],
    imageIconColor = _THEMES_CONFIG$theme.imageIconColor,
    titleColor = _THEMES_CONFIG$theme.titleColor,
    subtitleColor = _THEMES_CONFIG$theme.subtitleColor;
  return {
    addImageIcon: {
      color: imageIconColor,
      fontSize: isLargeScreen ? 22 : 24
    },
    uploadedImage: {
      height,
      width
    },
    title: {
      color: titleColor,
      type: "body-single-line-" + (isLargeScreen ? 'md' : 'sm')
    },
    subTitle: {
      color: subtitleColor,
      type: "body-single-line-" + (isLargeScreen ? 'md' : 'sm')
    },
    retryCta: {
      buttonType: 'tertiary',
      size: isLargeScreen ? 'md' : 'sm'
    }
  };
};
export var getUploadSingleFileStyles = (props, isLargeScreen, theme) => {
  var _props$state = props.state,
    state = _props$state === void 0 ? 'none' : _props$state;
  var spacing = tokens.spacing,
    borderRadius = tokens.borderRadius;
  var height = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var width = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var _THEMES_CONFIG$theme2 = THEMES_CONFIG[theme],
    containerBorderColor = _THEMES_CONFIG$theme2.containerBorderColor,
    imageIconBgColor = _THEMES_CONFIG$theme2.imageIconBgColor;
  return StyleSheet.create({
    container: {
      borderRadius: borderRadius.BORDER_RADIUS_16,
      borderStyle: 'dashed',
      borderWidth: 1,
      borderColor: state === 'error' ? RED_600 : containerBorderColor,
      padding: spacing.SPACING_16,
      marginTop: spacing.SPACING_16,
      flexDirection: 'row'
    },
    imageContainer: {
      flexShrink: 0,
      marginRight: isLargeScreen ? spacing.SPACING_20 : spacing.SPACING_12
    },
    addImageIcon: {
      flexShrink: 0,
      backgroundColor: imageIconBgColor,
      padding: isLargeScreen ? tokens.spacing.SPACING_14 : tokens.spacing.SPACING_8,
      height,
      width,
      borderRadius: borderRadius.BORDER_RADIUS_8
    },
    image: {
      borderRadius: borderRadius.BORDER_RADIUS_8
    },
    textContainer: {
      flex: 1,
      justifyContent: 'center'
    },
    subTitle: {
      marginTop: spacing.SPACING_4
    },
    actionContainer: {
      flexShrink: 0,
      marginLeft: isLargeScreen ? spacing.SPACING_20 : spacing.SPACING_12,
      alignSelf: 'center'
    },
    hintText: {
      marginTop: isLargeScreen ? spacing.SPACING_8 : spacing.SPACING_4
    }
  });
};